/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedTrackingContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedTrackingContainer_user$ref: FragmentReference;
export type SbSharedTrackingContainer_user = {|
  +serviceId: ?string,
  +isVerifiedTrade: ?boolean,
  +$fragmentRefs: SharedTrackingContainer_user$ref,
  +$refType: SbSharedTrackingContainer_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedTrackingContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ed8c22748cc9074e7803de32918e8933';
module.exports = node;
